import type { ReportWidgetColumnConfig } from '../../model/types';

export function getDefaultAlign(
    col: ReportWidgetColumnConfig,
): 'left' | 'right' | 'inherit' {
    if (col.align) return col.align;
    if (col.format === 'currency' || col.format === 'number') return 'right';
    return 'left';
}
